import { render } from "./Wrapper-tab-page.vue?vue&type=template&id=1913c94e"
import script from "./Wrapper-tab-page.vue?vue&type=script&lang=js"
export * from "./Wrapper-tab-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__